module.exports = __webpack_public_path__ + "static/media/LOGIN_PAGE_LOGO.b74321ed.png";